export default __webpack_public_path__ + "static/Tata-Class-Edge-3ae08668279508b1ce3981a88e0ffe1f.png";